function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

class SlimProductCTA extends HTMLElement {
  constructor() {
    super();
    this.selectElement = this.querySelector(
      ".product-cta-banner__selector--container [data-variant-input]"
    );
    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.submitButton = this.querySelector('[type="submit"]');

    this.inputSelectColor();
  }

  onSubmitHandler(evt) {
    evt.preventDefault();

    if (this.submitButton.getAttribute("aria-disabled") === "true") return;

    this.submitButton.setAttribute("aria-disabled", true);
    this.submitButton.classList.add("btn--loading");

    const selectedOption =
      this.selectElement.options[this.selectElement.selectedIndex].getAttribute(
        "data-variant-id"
      );

    fetch("/cart/add.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/json`,
      },
      body: JSON.stringify({
        id: selectedOption,
        quantity: 1,
        note: "CTA: " + selectedOption,
      }),
    })
      .then((response) => response.json())
      .then(function (data) {
        if (data.status === 422) {
          console.error(data);
        } else {
          var product = data;
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added", {
              detail: {
                product: product,
              },
            })
          );
        }
      })
      .catch((err) => alert(err))
      .finally(() => {
        this.submitButton.classList.remove("btn--loading");
        this.submitButton.setAttribute("aria-disabled", false);
      });
  }

  inputSelectColor() {
    if (this.selectElement.selectedIndex !== -1) {
      const selectedOption =
        this.selectElement.options[this.selectElement.selectedIndex];
      const hexColor =
        VARIANTS_METAFIELDS[selectedOption.getAttribute("data-variant-id")];

      if (!hexColor) return this.setBackgroundColor("--colorCartDot");

      this.setBackgroundColor(hexColor);
    }

    this.selectElement.addEventListener("change", (event) => {
      const selected =
        event.target.options[event.target.selectedIndex].getAttribute(
          "data-variant-id"
        );

      if (!VARIANTS_METAFIELDS[selected])
        return this.setBackgroundColor("var(--colorCartDot)");

      this.setBackgroundColor(VARIANTS_METAFIELDS[selected]);
    });
  }

  setBackgroundColor(color) {
    let container = document.querySelector(
      "[data-section-id=" + SECTION_ID + "]"
    );

    container.style.setProperty("--mut-background-color", color);
  }
}

customElements.define("slim-product-cta", SlimProductCTA);
